import Checkout from "../../../entities/checkout/checkout";
import Response from "../../../entities/checkout/checkout-response";

export default {
  checkout: new Checkout(),
  checkoutResponse: new Response()
};
